export default __webpack_public_path__ + "static/media/Icono14.dcd12efa.svg";